

/* tslint:disable */



export enum FlowchartLinkAttributeOperator {
    Equals = 1,
    NotEquals = 2,
    SmallerThan = 3,
    SmallerThanOrEquals = 4,
    BiggerThan = 5,
    BiggerThanOrEquals = 6,
    Between = 7,
    Includes = 8,

}


